import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs: React.FC = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="nav-bar__tabs">
      {isAuthenticated ? (
        <NavBarTab path="/dashboard" label="Dashboard" />
      ) : (
        <NavBarTab path="/" label="Home" />
      )}
      {isAuthenticated && (
        <NavBarTab path="/documents" label="My documents" />
      )}
      {/* Signed in, these three move into the corner menu (NavBarMenu) so the
          bar shows only the pages that belong to the signed-in user. */}
      {!isAuthenticated && (
        <>
          <NavBarTab
            path="/freebie-downloadables"
            label="Freebie downloadables"
          />
          <NavBarTab path="/pricing" label="Pricing" />
          <NavBarTab path="/about" label="About us" />
        </>
      )}
    </div>
  );
};
